<template>
  <v-snackbar
      v-model="snackbarOpen"
      bottom
      :timeout="snackbarTimeout"
    >
      {{ text ? textFirstLetterUppercase(text) : '' }}
      <v-btn
        color="primary"
        @click="setOpen(false)"
      >
        Close
      </v-btn>
    </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Helper from '@/components/Controllers/Helpers';
export default {
  name: 'Snackbar',
  computed: {
    snackbarOpen: {
      set(open) {
        return this.setOpen(open);
      },
      get() {
        return this.open;
      },
    },
    snackbarTimeout: {
      set(miliseconds) {
        return this.setTimeout(miliseconds);
      },
      get() {
        return this.timeout;
      },
    },
    ...mapGetters('snackbar', [
      'open',
      'text',
      'timeout',
    ]),
  },
  methods: {
    textFirstLetterUppercase(text){
      if(text) {
        return Helper.firstLetterUppercase(text);
      } else {
        return '';
      }
      
    },
    ...mapActions('snackbar', [
      'setOpen',
      'setTimeout',
    ]),
  },
};
</script>
